module.exports = __webpack_public_path__ + "img/wedding_thumbnail-1-400x300.b9e193fc.jpg";